<template>
    <AppChartWrapper
        :imageName="name"
        >
        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">{{ name | unescapeString }}</h4>
        <LineChart
                class="pt-2"
                slot="chart"
                v-if="summaryDataReady"
                :chartData="sentimentGraphLineChartData"
                :height="320"
                :options="sentimentGraphLineChartOptions"
                :width="490"
        />
    </AppChartWrapper>
</template>

<script>
	import LineChart from "@/components/LineChart";
	import {mapState} from "vuex";
	import moment from "moment";
	import {abbrNum, thousandSeperator} from "../../utils";
	import AppChartWrapper from "../AppChartWrapper";

	export default {
		data() {
			return {
				sentimentGraphLineChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						display: true
					},
					tooltips: {
						mode: "index",
						intersect: false,
                        callbacks:{
							beforeTitle(){
								this.total = 0
                            },
							label(item, datasets){
                                let total = datasets.datasets.map(dataset => dataset.data[item.index]).reduce((acc,cur) => acc + cur);
                                this.total = total;
                                let label = datasets.datasets[item.datasetIndex].label;
                                let percentage = (parseFloat((item.value / this.total) * 100)).toFixed(1);
                                let text = total ? `${label}: ${thousandSeperator(item.value)} (${percentage}%)` : `${label}: ${thousandSeperator(item.value)}`;
                                return text;
                            },
                            footer(items, datasets){
								return `Total ${thousandSeperator(this.total)}`;
                            }
                        }
					},
					hover: {
						mode: "nearest",
						intersect: true
					},
					layout: {
						padding: {
							top: 10,
							left: 10,
							right: 10
						}
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								ticks: {
									barThickness: 3
								}
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 15,
                                    callback(value, index, values){
										return abbrNum(value, 2);
                                    }
								}
							}
						]
					}
				}
			}
		},
		props: {

            sentimentData:{
            	type:Object,
                default(){
            		return {}
                }
            },

            name: {
                type: String,
                default: "Sentiment Over Time"
            },

			categoryColor: {
				type: Object,
				required: true
			},

            summaryDataReady: {
				type: Boolean,
                required: true,
            },

			sentimentGraphSuggestedMax:{
				type: Number,
                default: 0
            }
		},

		computed: {
			...mapState(["facebookSummary"]),

			...mapState("mention", ["summaryReady"]),

			...mapState("sentiment", ["sentimentPageReady"]),

            categoryRangeOrdered(){
				let categories = ["positive","negative","neutral","interest"];
				return categories.map(category => {
					return this.sentimentData.range.find(sentiment => sentiment.value === category)
				}).filter(category => !!category);
            },

			sentimentGraphLineChartData() {
                if(this.categoryRangeOrdered.length < 1) return {};
				const dates = this.categoryRangeOrdered[0].ranges.fb_created_dt.counts.filter((i, idx) => idx % 2 === 0);
				const fdates = dates.map(i => moment(i).format("YYYY-MM-DD"));
				const datasets = this.categoryRangeOrdered.map(t => {
					return {
						label: t.value,
						data: t.ranges.fb_created_dt.counts.filter((j, jdx) => jdx % 2 !== 0),
						backgroundColor: this.categoryColor[t.value],
						borderColor: this.categoryColor[t.value],
						fill: false
					};
				});
				return {
					labels: fdates,
					datasets
				};
			}
		},

		watch: {
			sentimentGraphSuggestedMax: {
				handler(val) {
					if (val && val !== 0) {
						let yScale = this.sentimentGraphLineChartOptions.scales.yAxes;
						let scale = yScale[0];
						scale.ticks.suggestedMax = val;
						this.$set(this.sentimentGraphLineChartOptions.scales.yAxes, 0, scale)
					}
				},
				immediate: true
			}
		},

		components: {
			AppChartWrapper,
			LineChart
		}
	};
</script>

<style scoped>
    .chart-container {
        width: 51vw;
        position: relative;
    }

    .chart-wrapper > div:first-child {
        margin-top: -14px;
        margin-left: -14px;
    }
</style>
